import { render, staticRenderFns } from "./serviceuserpower.vue?vue&type=template&id=17f0642e&scoped=true&"
import script from "./serviceuserpower.vue?vue&type=script&lang=js&"
export * from "./serviceuserpower.vue?vue&type=script&lang=js&"
import style0 from "./serviceuserpower.vue?vue&type=style&index=0&id=17f0642e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f0642e",
  null
  
)

export default component.exports